import React from "react";

var certificateSvg = function certificateSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.441 12.363l.043-.063.013.017.003-.003V12.31c1.076.905 2.63.9 3.696.066l.304 3.62c-1.564-.587-2.67-1.252-3.316-1.996H7.82c-.646.746-1.753 1.412-3.32 2l.304-3.62a2.946 2.946 0 0 0 3.637-.017zm-1.269-1.575a.896.896 0 0 1-1.472-.61A2.055 2.055 0 0 0 3.822 8.3a.896.896 0 0 1-.61-1.472 2.055 2.055 0 0 0 0-2.656.896.896 0 0 1 .61-1.472c1-.083 1.795-.877 1.878-1.878a.896.896 0 0 1 1.472-.61c.767.649 1.89.649 2.656 0a.896.896 0 0 1 1.472.61c.083 1 .877 1.795 1.878 1.878a.896.896 0 0 1 .61 1.472 2.055 2.055 0 0 0 0 2.656.896.896 0 0 1-.61 1.472c-1 .083-1.795.877-1.878 1.878a.896.896 0 0 1-1.472.61 2.055 2.055 0 0 0-2.656 0z",
    fillRule: "evenodd"
  }));
};

certificateSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var certificate = {
  category: 'icon',
  colorable: true,
  name: 'certificate',
  svg: certificateSvg
};